import React from "react";
import { trackClickEvent } from "@foundation/nextjs-gtm";
import { TransparentButton } from "@bloomberg/media-ui-core";
import { Plus } from "@bloomberg/media-ui-icons";
import styles from "./styles.module.css";
import { PortfolioFormHolding } from "~types/portfolio";
import HoldingRow from "~components/Portfolio/PortfolioForm/HoldingRow";
import LotsRow from "~components/Portfolio/PortfolioForm/LotsRow";

type HoldingLineProps = {
  index: number;
  holding: PortfolioFormHolding;
  onRemove: (index: number) => void;
  onAddLot: (index: number) => void;
};

export default function HoldingLine(props: HoldingLineProps) {
  const { index, holding, onRemove, onAddLot } = props;
  const handleHoldingRemove = () => {
    trackClickEvent(
      "watchlistDeleteSymbol",
      "delete_symbol",
      "click",
      "watchlist"
    );

    onRemove(index);
  };

  const handleAddLot = () => {
    trackClickEvent("watchlistAddLot", "add_lot", "click", "watchlist");

    onAddLot(index);
  };

  return (
    <>
      <HoldingRow onRemoveClick={handleHoldingRemove} holding={holding} />

      <LotsRow holding={holding} holdingIndex={index} />

      <div className={styles.row}>
        <div className={styles.cell}>
          <TransparentButton
            className={styles.addLotButton}
            Icon={<Plus />}
            onClick={handleAddLot}
            size={"small"}
          >
            Add Lot
          </TransparentButton>
        </div>
      </div>

      <div className={styles.separator} />
    </>
  );
}
